import {fonts} from '../../theme/foundations/fonts'
import {pxToRem} from '../../utills/pxToRem'

export const loginFormStyle = {
    label: {
        fontSize: 'md',
        fontStyle: 'normal',
        lineHeight: 'normal',
        mb: pxToRem(15),
        letterSpacing: pxToRem(1.28),
        color: '#000'
    },
    input: {
        borderRadius: 'initial'
    }
}

export const styleAccountBenefits = {
    '.benefits': {
        display: 'flex',
        columnGap: pxToRem(10),
        marginTop: [pxToRem(20), pxToRem(20), pxToRem(20), pxToRem(20)],
        marginBottom: [pxToRem(5), pxToRem(5), pxToRem(20), pxToRem(20)],
        div: {
            flex: '1',
            img: {
                height: [pxToRem(43), pxToRem(43), pxToRem(59), pxToRem(59)],
                margin: '0 auto',
                marginBottom: pxToRem(10)
            },
            p: {
                color: 'black',
                fontFamily: fonts.primary,
                textAlign: 'center',
                fontSize: [pxToRem(9), pxToRem(9), pxToRem(13), pxToRem(13)],
                fontWeight: '400',
                lineHeight: 'normal',
                letterSpacing: pxToRem(1),
                margin: 0
            }
        }
    }
}
